import "./Login.scss";
import { Button, Col, Flex, Grid, Layout, Row } from "antd";
import React, { useState } from "react";
import LoginForm from "../../components/Forms/LoginForm";
import Logo from "../../components/Logo/Logo";
import LoginFormCode from "../../components/Forms/LoginFormCode";
import { ILoginViewProps } from "../..";
import { useNavigate } from "react-router-dom";
import PublicMenu from "../../components/Menu/PublicMenu";
import Footer from "../../components/Footer/Footer";
const { useBreakpoint } = Grid;
const LoginView: React.FC = (props: ILoginViewProps) => {
  const navigate = useNavigate();
  const screens = useBreakpoint();

  return (
    <>
      <Layout style={{ height: "100vh", background: "none" }}>
        <Row className={screens.xs ? "movil-view" : "login-view"} justify={"center"} align={"middle"}>
            <div className="menu-movil">
              <PublicMenu />
            </div>
          <Col xs={24} lg={10}>
            <Col offset={0} xs={24} className={screens.xs ? "text-centered" : ''} >
              <Logo size={"100%"} />
            </Col>
            <Col offset={0} xs={24}>
              <h2 className={screens.xs ? "text-centered" : ''}>Iniciar sesión</h2>
              <br></br>
            </Col>
            {process.env.REACT_APP_LOGIN_MODE &&
              process.env.REACT_APP_LOGIN_MODE.match("code") ? (
              <LoginFormCode />
            ) : (
              <LoginForm />
            )}
            <p className='flex-centered' style={{ margin: 0 }}>¿No tienes cuenta aún?<a href="#/" onClick={($event) => {
              $event.preventDefault();
              navigate("/register");
            }} style={{ marginLeft: 10, color: '#f37221' }}>{'Crear cuenta'}</a></p>
          </Col>
          <Col className="image hidde-mobile" xs={24} lg={14}></Col>
          { screens.xs ? (<Footer />) : (null)}
        </Row>
      </Layout>
    </>
  );
};

export default LoginView;
